import { BehaviourDataActionTypes } from '../constants/ApiConstants';

const initialState = {
  loading: false,
  recordABCDataList: null,
  saved_RecordABCData: null,
  saved_RecordFrequencyData: null,
  frequencyDataList: null,
  recordDurationDataList: null,
  patientTodaysRecordABCDataList: null,
  patientTodaysRecordFrequencyDataList: null,
  patientTodaysRecordDurationDataList: null,
  patientTodaysRecordRateDataList: null,
  patientTodaysRecordIntervalDataList: null,
  deleted_patientTodaysRecordABCDataList: null,
  deleted_patientTodaysRecordFrequencyDataList: null,
  deleted_patientTodaysRecordDurationDataList: null,
  deleted_patientTodaysRecordRateDataList: null,
  deleted_patientTodaysRecordIntervalDataList: null,
  updatedCollectedBehaviorDataStatus: null,
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case BehaviourDataActionTypes.save_patientRecordABCData.REQUEST:
      return {
        ...state,
        loading: true,
        saved_RecordABCData: null,
      };
    case BehaviourDataActionTypes.save_patientRecordABCData.SUCCESS:
      return {
        ...state,
        loading: false,
        saved_RecordABCData: payload,
      };
    case BehaviourDataActionTypes.save_patientRecordFrequencyData.REQUEST:
      return {
        ...state,
        loading: true,
        saved_RecordFrequencyData: null,
      };
    case BehaviourDataActionTypes.save_patientRecordFrequencyData.SUCCESS:
      return {
        ...state,
        loading: false,
        saved_RecordFrequencyData: payload,
      };
    case BehaviourDataActionTypes.get_patientRecordABCData_List.REQUEST:
      return {
        ...state,
        loading: true,
        recordABCDataList: null,
      };
    case BehaviourDataActionTypes.get_patientRecordABCData_List.SUCCESS:
      return {
        ...state,
        loading: false,
        recordABCDataList: payload,
      };
    case BehaviourDataActionTypes.get_patientRecordFrequencyData.REQUEST:
      return {
        ...state,
        loading: true,
        frequencyDataList: null,
      };
    case BehaviourDataActionTypes.get_patientRecordFrequencyData.SUCCESS:
      return {
        ...state,
        loading: false,
        frequencyDataList: payload,
      };
    case BehaviourDataActionTypes.get_patientRecordDurationData.REQUEST:
      return {
        ...state,
        loading: true,
        recordDurationDataList: null,
      };
    case BehaviourDataActionTypes.get_patientRecordDurationData.SUCCESS:
      return {
        ...state,
        loading: false,
        recordDurationDataList: payload,
      };
    case BehaviourDataActionTypes.set_isRecordDurationRenderTrue.SUCCESS:
      return {
        ...state,
        loading: false,
        isRecordDurationRenderTrue: payload,
      };

    case BehaviourDataActionTypes.get_patientTodaysRecordABCDataList.REQUEST:
      return {
        ...state,
        loading: true,
        patientTodaysRecordABCDataList: null,
      };
    case BehaviourDataActionTypes.get_patientTodaysRecordABCDataList.SUCCESS:
      return {
        ...state,
        loading: false,
        patientTodaysRecordABCDataList: payload,
      };

    case BehaviourDataActionTypes.get_patientTodaysDurationDataList.REQUEST:
      return {
        ...state,
        loading: true,
        patientTodaysRecordDurationDataList: null,
      };
    case BehaviourDataActionTypes.get_patientTodaysDurationDataList.SUCCESS:
      return {
        ...state,
        loading: false,
        patientTodaysRecordDurationDataList: payload,
      };

    case BehaviourDataActionTypes.get_patientTodaysFrequencyDataList.REQUEST:
      return {
        ...state,
        loading: true,
        patientTodaysRecordFrequencyDataList: null,
      };
    case BehaviourDataActionTypes.get_patientTodaysFrequencyDataList.SUCCESS:
      return {
        ...state,
        loading: false,
        patientTodaysRecordFrequencyDataList: payload,
      };

      case BehaviourDataActionTypes.get_patientTodaysRateDataList.REQUEST:
        return {
          ...state,
          loading: true,
          patientTodaysRecordRateDataList: null,
        };
      case BehaviourDataActionTypes.get_patientTodaysRateDataList.SUCCESS:
        return {
          ...state,
          loading: false,
          patientTodaysRecordRateDataList: payload,
        };

        case BehaviourDataActionTypes.get_patientTodaysIntervalDataList.REQUEST:
        return {
          ...state,
          loading: true,
          patientTodaysRecordIntervalDataList: null,
        };
      case BehaviourDataActionTypes.get_patientTodaysIntervalDataList.SUCCESS:
        return {
          ...state,
          loading: false,
          patientTodaysRecordIntervalDataList: payload,
        };

    case BehaviourDataActionTypes.delete_patientTodaysRecordABCDataList.REQUEST:
      return {
        ...state,
        loading: true,
        deleted_patientTodaysRecordABCDataList: null,
      };
    case BehaviourDataActionTypes.delete_patientTodaysRecordABCDataList.SUCCESS:
      return {
        ...state,
        loading: false,
        deleted_patientTodaysRecordABCDataList: payload,
      };

    case BehaviourDataActionTypes.delete_patientTodaysDurationDataList.REQUEST:
      return {
        ...state,
        loading: true,
        deleted_patientTodaysRecordDurationDataList: null,
      };
    case BehaviourDataActionTypes.delete_patientTodaysDurationDataList.SUCCESS:
      return {
        ...state,
        loading: false,
        deleted_patientTodaysRecordDurationDataList: payload,
      };

    case BehaviourDataActionTypes.delete_patientTodaysRateDataList.REQUEST:
      return {
        ...state,
        loading: true,
        deleted_patientTodaysRecordRateDataList: null,
      };
    case BehaviourDataActionTypes.delete_patientTodaysRateDataList.SUCCESS:
      return {
        ...state,
        loading: false,
        deleted_patientTodaysRecordRateDataList: payload,
      };

      case BehaviourDataActionTypes.delete_patientTodaysIntervalDataList.REQUEST:
      return {
        ...state,
        loading: true,
        deleted_patientTodaysRecordIntervalDataList: null,
      };
    case BehaviourDataActionTypes.delete_patientTodaysIntervalDataList.SUCCESS:
      return {
        ...state,
        loading: false,
        deleted_patientTodaysRecordIntervalDataList: payload,
      };

    case BehaviourDataActionTypes.delete_patientTodaysFrequencyDataList.REQUEST:
      return {
        ...state,
        loading: true,
        deleted_patientTodaysRecordFrequencyDataList: null,
      };
    case BehaviourDataActionTypes.delete_patientTodaysFrequencyDataList.SUCCESS:
      return {
        ...state,
        loading: false,
        deleted_patientTodaysRecordFrequencyDataList: payload,
      };
    case BehaviourDataActionTypes.update_collectedBehaviorDataStatus.REQUEST:
      return {
        ...state,
        //loading: true,
        updatedCollectedBehaviorDataStatus: null,
      };
    case BehaviourDataActionTypes.update_collectedBehaviorDataStatus.SUCCESS:
      return {
        ...state,
        //loading: false,
        updatedCollectedBehaviorDataStatus: payload,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/patients/components/collectData/componnets/BehaviorData/reducers/BehaviourDataReducers.js